import {
  GraphQLErrorCode,
  GraphQLInternalErrorCode,
} from '@this+that/constants';

import { TerminalSendFailure } from '../../../enums/terminal';
import {
  getGraphQLErrorCode,
  getInternalErrorCode,
} from '../../../utils/graphqlErrors';

const INTERNAL_CODE_FAILURES: Partial<
  Record<GraphQLInternalErrorCode, TerminalSendFailure>
> = {
  [GraphQLInternalErrorCode.TERMINAL_DEVICE_OFFLINE]:
    TerminalSendFailure.DEVICE_OFFLINE,
  [GraphQLInternalErrorCode.TERMINAL_MESSAGE_TOO_LARGE]:
    TerminalSendFailure.TOO_LARGE,
  [GraphQLInternalErrorCode.TERMINAL_MESSAGE_INVALID]:
    TerminalSendFailure.INVALID,
};

export function classifyTerminalError(error: unknown): TerminalSendFailure {
  const internal = getInternalErrorCode(error);
  if (internal && INTERNAL_CODE_FAILURES[internal]) {
    return INTERNAL_CODE_FAILURES[internal];
  }
  if (getGraphQLErrorCode(error) === GraphQLErrorCode.NOT_FOUND) {
    return TerminalSendFailure.NOT_FOUND;
  }
  return TerminalSendFailure.UNKNOWN;
}
